// extracted by mini-css-extract-plugin
module.exports = {"default":"_type_default__2Vetr"};